'use client'

import DiscoverySearchForm from '@/components/search/discovery-search-form'

export default function CastingSearchFilters(props) {
  return (
    <div className="screen-grid bg-neutral-blue-950 col-span-full w-full rounded-b-xl pb-8 pt-8">
      <div className="col-span-full desktop-sm:col-span-10 desktop-sm:col-start-2">
        <h1 className="mb-6 text-h-2-sm font-bold">
          Find a Broadcaster or Commentator
        </h1>
        <DiscoverySearchForm {...props} mode="casting" />
      </div>
    </div>
  )
}
